var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlans = function SvgPlans(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3327 8.33398V5.00065C18.3327 4.08398 17.5827 3.33398 16.666 3.33398H3.33268C2.41602 3.33398 1.67435 4.08398 1.67435 5.00065V8.33398C2.59102 8.33398 3.33268 9.08398 3.33268 10.0007C3.33268 10.9173 2.59102 11.6673 1.66602 11.6673V15.0007C1.66602 15.9173 2.41602 16.6673 3.33268 16.6673H16.666C17.5827 16.6673 18.3327 15.9173 18.3327 15.0007V11.6673C17.416 11.6673 16.666 10.9173 16.666 10.0007C16.666 9.08398 17.416 8.33398 18.3327 8.33398ZM16.666 7.11732C15.6743 7.69232 14.9993 8.77565 14.9993 10.0007C14.9993 11.2257 15.6743 12.309 16.666 12.884V15.0007H3.33268V12.884C4.32435 12.309 4.99935 11.2257 4.99935 10.0007C4.99935 8.76732 4.33268 7.69232 3.34102 7.11732L3.33268 5.00065H16.666V7.11732ZM9.99939 11.7673L7.55772 13.334L8.29105 10.5257L6.04939 8.69232L8.94105 8.51732L9.99939 5.83398L11.0494 8.52565L13.9411 8.70065L11.6994 10.534L12.4411 13.334L9.99939 11.7673Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlans, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plans.5074bbdf.svg";
export { ForwardRef as ReactComponent };